import { render, staticRenderFns } from "./ModalCaption.vue?vue&type=template&id=478a9ba7&scoped=true"
import script from "./ModalCaption.vue?vue&type=script&lang=js"
export * from "./ModalCaption.vue?vue&type=script&lang=js"
import style0 from "./ModalCaption.vue?vue&type=style&index=0&id=478a9ba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a9ba7",
  null
  
)

export default component.exports